<mat-card class="sdp-reset-password">
	<h3 class="sdp-header-no-margin-top">{{ "resetpassword.title" | translate }}</h3>
	<div>
		{{ "resetpassword.description" | translate }}.
	</div>
	<form
		[formGroup]="resetPasswordForm"
		(ngSubmit)="submit()"
		novalidate
	>
		<div class="sdp-form-control">
			<mat-form-field class="sdp-form-control-input-container">
				<input
					matInput
					placeholder="{{ 'form.label.currentPassword' | translate }}"
					type="password"
					formControlName="currentPassword"
				>
				<mat-error *ngIf="resetPasswordForm.controls['currentPassword'].hasError('required')">{{ "error.message.currentPassword" | translate }}</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-form-control">
			<mat-form-field class="sdp-form-control-input-container">
				<input
					matInput
					placeholder="{{ 'form.label.newPassword' | translate }}"
					type="{{ passwordType }}"
					formControlName="password"
				>
				<mat-error *ngIf="resetPasswordForm.controls['password'].hasError('required')">{{ "error.message.password" | translate }}</mat-error>
				<mat-error *ngIf="resetPasswordForm.controls['password'].hasError('minlength')">{{ "error.message.passwordLength" | translate }}</mat-error>
			</mat-form-field>
			<div
				class="sdp-password-show"
				[class.sdp-text-input]="passwordType==='text'"
			>
				<sdp-icon
					[icon]="passwordIcon"
					(click)="passwordType = passwordType==='text'?'password':'text'"
				></sdp-icon>
			</div>
			<div class="sdp-password-strength-container">
				<ng2-password-strength-bar
					[passwordToCheck]="resetPasswordForm.get('password')!.value"
					barLabel="{{ 'password.strength.label' | translate }}"
				></ng2-password-strength-bar>
			</div>
		</div>
		<div class="sdp-form-control">
			<mat-form-field class="sdp-form-control-input-container">
				<input
					matInput
					placeholder="{{ 'form.label.confirmNewPassword' | translate }}"
					type="{{ passwordType }}"
					formControlName="confirmPassword"
				>
				<mat-error *ngIf="resetPasswordForm.controls['confirmPassword'].hasError('confirmNoMatch')">{{ "error.message.passwordMatch" | translate }}</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-form-control sdp-form-buttons-container">
			<button
				mat-raised-button
				color="primary"
				type="submit"
				[disabled]="!resetPasswordForm.valid"
			>{{ "resetpassword.title" | translate }}</button>
		</div>
	</form>
	<mat-progress-bar
		mode="indeterminate"
		*ngIf="isDoingWork"
		class="sdp-progress-bar"
	></mat-progress-bar>
</mat-card>